module.exports = __webpack_public_path__ + "img/a3-s73.4905deb9.jpg";